<template>
  <div  
  >
    <v-btn v-for="(item, i) in items.slice(0, large ? items.length : 3)"
      :key="i"
      fab
      class="ma-2"
      :large="large"
      color="info"
      v-bind:href="item.link"
    >
      <v-icon
        dark
        v-text="item.icon"
      />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    large: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    items: [
      {
        name: 'Email',
        icon: 'mdi-email',
        link: 'mailto:info@greenowl-it.com'
      },
      {
        name: 'Phone',
        icon: 'mdi-phone',
        link: 'tel:4915906346024'
      }
    ]
  })
}
</script>
